import { AdminRepository } from "@/domain/repository/admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeactivateDoctorUsecase {
  constructor(private readonly adminRepository: AdminRepository) {}

  async execute(doctorUuid: string): Promise<SATResult<void, SATError>> {
    const result = await this.adminRepository.deactivateDoctor(doctorUuid);

    if (result.isSuccess) {
      console.log("[DeactivateDoctorUsecase] :: execute :: 의사 계정 비활성화 성공", result.value);
      return SATResult.success(result.value);
    }

    console.log("[DeactivateDoctorUsecase] :: execute :: 의사 계정 비활성화 실패", result.error);
    return SATResult.failure(result.error);
  }
}
